import { environment } from '@environment';
import { NgxsModuleOptions, NoopNgxsExecutionStrategy } from '@ngxs/store';

export const ngxsConfig: NgxsModuleOptions = {
  developmentMode: !environment.isProdBuild,
  executionStrategy: NoopNgxsExecutionStrategy,
  compatibility: {
    strictContentSecurityPolicy: true,
  },
  selectorOptions: {
    suppressErrors: false,
    injectContainerState: true,
  },
};
